import React from "react";
import { Carousel } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

const Slideshow = ({ images }) => {
  if (!images || images.length === 0) {
    return <p>No images to display</p>;
  }

  return (
    <Carousel>
      {images.map((image) => (
        <Carousel.Item key={image.id}>
          <img
            className="d-block w-100"
            src={image.src}
            alt={`Slide ${image.id}`}
          />
        </Carousel.Item>
      ))}
    </Carousel>
  );
};

export default Slideshow;
